import { createContext, memo, useContext } from 'react';
import type { PropsWithChildren } from 'react';

const WithoutAnswersContext = createContext(false);

export const WithoutAnswersProvider = memo(function WithoutAnswersProvider(
  props: PropsWithChildren<{}>,
) {
  const { children } = props;

  return <WithoutAnswersContext.Provider value={true}>{children}</WithoutAnswersContext.Provider>;
});

/** In a yakli link, when there are too many messages and intermediate messages are hidden (not loaded yet), the first message is still loaded, but without children. This flag indicates children should be skipped in the rendering. */
export function useWithoutAnswers() {
  return useContext(WithoutAnswersContext);
}
